import { useConsultationsList } from "features/consultations/hooks/useConsultationsList";
import { useCurrentPatientId } from "features/patients/hooks/useCurrentPatientId";

import styles from "../../PatientOverviewModal.module.css";
import { Table } from "./Table/Table";

export const Consultations = (patientIdVal) => {
  const currentPatientId = useCurrentPatientId();

  const { data: consultationsList, isLoading } = useConsultationsList(
    currentPatientId ? currentPatientId : patientIdVal
  );

  return (
    <div className={styles.medicalHistoryWrapper}>
      <Table items={consultationsList || []} isLoading={isLoading} />
    </div>
  );
};
